import React, { FC } from 'react';

interface TopSellersProps {
  sellers?: [string, number][] | null;
  title?: string;
}

const medals = ['🥇', '🥈', '🥉'];
const medalColor = (i: number) => i === 0 ? '#f59e0b' : i === 1 ? '#94a3b8' : i === 2 ? '#b45309' : '#163172';

const fmt = (n: number) => `$${Number(n).toLocaleString('en-US', { minimumFractionDigits: 2 })}`;

const TopSellers: FC<TopSellersProps> = ({ sellers, title = 'Top Sellers' }) => {
  const list = sellers?.slice(0, 5) ?? [];
  const maxAmount = list.length > 0 ? Math.max(...list.map(s => Number(s[1])), 1) : 1;

  return (
    <div className="bg-white rounded-3 shadow-sm p-4 h-100" style={{ border: '1px solid #f0f0f0' }}>
      <h6 className="fw-bold mb-3" style={{ color: '#1a1a2e', fontSize: 12, textTransform: 'uppercase', letterSpacing: '0.06em' }}>
        {title}
      </h6>
      {list.length === 0 ? (
        <p className="text-muted small text-center py-3 mb-0">No sales data yet</p>
      ) : (
        <div className="d-flex flex-column gap-3">
          {list.map(([name, amount], idx) => {
            const barPct = Math.round((Number(amount) / maxAmount) * 100);
            return (
              <div key={idx}>
                <div className="d-flex align-items-center justify-content-between mb-1">
                  <div className="d-flex align-items-center gap-2" style={{ minWidth: 0, flex: 1 }}>
                    <span style={{ fontSize: 16, lineHeight: 1, flexShrink: 0 }}>{medals[idx] ?? `${idx + 1}.`}</span>
                    <p className="fw-semibold mb-0 text-truncate" style={{ fontSize: 13, color: '#1a1a2e' }}>{name}</p>
                  </div>
                  <p className="fw-bold mb-0 ms-2 flex-shrink-0" style={{ fontSize: 13, color: '#1a1a2e' }}>
                    {fmt(Number(amount))}
                  </p>
                </div>
                <div className="rounded-pill overflow-hidden" style={{ height: 4, background: '#f1f5f9' }}>
                  <div style={{ height: '100%', width: `${barPct}%`, background: medalColor(idx), borderRadius: 4, transition: 'width 0.5s' }} />
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default TopSellers;
